import axios from 'axios'
import { getAuthToken, clearAuthData } from '../utils/authManager'

const API_HOST = process.env.REACT_APP_API_HOST
const PUBLIC_URL = process.env.REACT_APP_PUBLIC_URL
const BACKEND_ACCESS_KEY = process.env.REACT_APP_BACKEND_ACCESS_KEY

let isRefreshing = false
let pendingQueue = []

const processQueue = (error, token = null) => {
  pendingQueue.forEach(prom => {
    if (error) prom.reject(error)
    else prom.resolve(token)
  })
  pendingQueue = []
}

const handler = ({ baseURL = API_HOST, url = null, method = 'get', args = {}, isFile = false, signal = null }) => {
  const request = {}

  request.url = url
  request.baseURL = baseURL
  request.method = method.toLowerCase()
  
  // Initialize headers
  request.headers = {
    authorization: getAuthToken(), // Use secure token getter
    backendAccessKey: BACKEND_ACCESS_KEY
  }
  
  // Only set Content-Type for non-file requests
  // For file uploads, let axios automatically set Content-Type with boundary
  if (!isFile) {
    request.headers['Content-Type'] = 'application/json'
  }

  if (request.method === 'get') request.params = args
  else request.data = args

  // Add signal for request cancellation if provided
  if (signal) {
    request.signal = signal
  }

  return axios(request).then(
    response => {
      return response.data
    },
    async error => {
      const originalRequest = error.config
      if (error?.response) {
        const err = error.response.data?.error
        const shouldRefresh =
          err === 'jwt expired' ||
          err === 'token expired' ||
          error.response?.data?.payload?.error === 'token expired' ||
          error.response?.data?.payload?.error === 'jwt expired' ||
          err === 'UnAuthorized - Authorization required!'

        if (shouldRefresh && !originalRequest._retry) {
          originalRequest._retry = true

          if (isRefreshing) {
            return new Promise((resolve, reject) => {
              pendingQueue.push({ resolve, reject })
            })
              .then(token => {
                originalRequest.headers.authorization = token
                return axios(originalRequest)
              })
              .catch(e => {
                clearAuthData()
                window.location.href = PUBLIC_URL + '/login'
                return {}
              })
          }

          isRefreshing = true
          try {
            const refreshRes = await axios({
              baseURL: API_HOST,
              url: '/auth/user/refresh',
              method: 'post',
              headers: { authorization: getAuthToken(), backendAccessKey: BACKEND_ACCESS_KEY }
            })
            const data = refreshRes.data
            if (data && (data.code === 200 || data.code === 201) && data.payload?.authorization) {
              const newToken = data.payload.authorization
              // persist new token using authManager
              try {
                const { setAuthToken, setAuthUserData } = await import('../utils/authManager')
                setAuthToken(newToken)
                if (data.payload?.userData) {
                  setAuthUserData(data.payload.userData)
                }
              } catch (e) {
                console.error('Error storing refreshed token:', e)
              }
              processQueue(null, newToken)
              originalRequest.headers.authorization = newToken
              return axios(originalRequest)
            }
          } catch (e) {
            processQueue(e, null)
            clearAuthData()
            window.location.href = PUBLIC_URL + '/login'
            return {}
          } finally {
            isRefreshing = false
          }
        }

        return error.response.data
      } else {
        return {}
      }
    }
  )
}

export default handler
